import React from 'react';
import { observer } from 'mobx-react-lite';

export const CirclesSection = observer(
  ({ innerRef, circles = [], inner = false, invisibleOne = null }) => {
    if (inner === true) {
      return circles.map(({ color, id }, index) => {
        if (index === 0) {
          return (
            <div key={id} className='mob-h-a-c-bl mob-all-child'>
              <div
                ref={innerRef}
                className={`mob-h-all-c ${color} ${invisibleOne === index ? 'clear' : ''}`}
              />
            </div>
          );
        }
        return (
          <div key={id} className='mob-h-a-c-bl mob-all-child'>
            <div className={`mob-h-all-c ${color} ${invisibleOne === index ? 'clear' : ''}`} />
          </div>
        );
      });
    }
    return circles.map(({ color, id }) => (
      <div key={id} className='mob-a-c-bl mob-all-child'>
        <div className={`mob-all-cercle ${color}`} />
      </div>
    ));
  }
);
